import { render } from "./companyPage.vue?vue&type=template&id=f8cc6d92&ts=true"
import script from "./companyPage.ts?vue&type=script&lang=ts"
export * from "./companyPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__